<template>
  <div class="main">
    <div class="btns">
      <div v-if="searchValIsHide" class="leftSearch">
        <div>
          <a-button
            type="primary"
            @click="addNursingPopup = true"
            style="margin-right: 20px"
            >添加护工账号</a-button
          >
          <a-input-search
            placeholder="请输入姓名或手机号"
            style="width: 240px"
            v-model="searchVal"
            @search="onSearch"
          />
        </div>
        <p>
          共 <span>{{ tableData.length }}</span> 位护理人员
        </p>
      </div>
      <div v-else>
        <span
          >关于“{{ searchVal }}”共搜索到<span style="color: #1890ff">
            {{ total }} </span
          >条结果</span
        >
        <span
          @click="backBtn"
          style="color: #1890ff; cursor: pointer; margin-left: 20px"
          >返回</span
        >
      </div>
    </div>
    <div v-if="total != 0">
      <a-table
        :columns="columns"
        :data-source="tableData"
        bordered
        :pagination="false"
        rowKey="userId"
      >
        <template slot="beds" slot-scope="scope">
          <div class="addBed">
            <div class="bedChoice" v-if="scope.beds">
              <div
                class="bedItem"
                v-for="(item, index) in scope.beds"
                :key="index"
              >
                <span>{{ item.bedName }}</span
                ><a-icon
                  type="close-circle"
                  theme="filled"
                  class="close"
                  @click="delBed(item.bedId, scope.userId)"
                />
              </div>
              <div class="addBtn" @click="addBedClick(scope)">
                <a-icon
                  type="plus-circle"
                  theme="filled"
                  class="iconBtn"
                />添加床位
              </div>
            </div>
            <div class="addBtn" v-else @click="addBedClick(scope)">
              <a-icon
                type="plus-circle"
                theme="filled"
                class="iconBtn"
              />添加床位
            </div>
          </div>
        </template>
        <template slot="operation" slot-scope="scope">
          <div class="operation">
            <!-- <div class="tableImg1"></div> -->
            <a-icon type="form" @click="edit(scope)" class="tableIcon" />
            <div class="tableImg" @click="delAccount(scope)"></div>
            <!-- <img src="../../assets/icon_trashCan_nor.png" class="tableImg" @mouseover="overShow" @mouseout="outHide"> -->
          </div>
        </template>
      </a-table>
    </div>
    <a-empty v-else />
    <a-pagination
      v-model="pageNum"
      :total="total"
      @change="pageChange"
      :pageSize="20"
      :hideOnSinglePage="true"
      show-less-items
      style="text-align: center; margin-top: 20px"
    />
    <!-- 添加护工账号  -->
    <a-modal
      title="添加护工账号"
      :visible="addNursingPopup"
      :maskClosable="false"
      :width="400"
      @cancel="addNursingOff"
      :footer="null"
    >
      <a-form>
        <a-form-item label="">
          <div class="login_input" :style="{ borderColor: nameColor }">
            <input
              type="text"
              maxlength="18"
              v-model="addListData.name"
              placeholder="请输入姓名"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="nameIcon"
            />
          </div>
          <p class="tips" :style="{ color: nameColor }">
            {{ nameTips }}
          </p>
        </a-form-item>
        <a-form-item label="">
          <div class="login_input" :style="{ borderColor: phoneColor }">
            <input
              type="text"
              autocomplete="off"
              maxlength="11"
              v-model="addListData.phone"
              placeholder="请输入手机号"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="phoneIcon"
            />
          </div>
          <p class="tips" :style="{ color: phoneColor }" v-if="phoneIcon">
            {{ phoneTips }}
          </p>
        </a-form-item>
        <a-form-item label="">
          <div class="login_input" :style="{ borderColor: passwordColor }">
            <input
              type="text"
              placeholder="请输入密码"
              autocomplete="off"
              v-model="addListData.password"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="passwordIcon"
            />
          </div>
          <p class="tips" :style="{ color: passwordColor }" v-if="passwordIcon">
            密码不可为空
          </p>
        </a-form-item>
        <a-form-item label="">
          <div class="login_input" :style="{ borderColor: sparePhoneColor }">
            <input
              type="text"
              autocomplete="off"
              maxlength="11"
              v-model="addListData.reserveMobile"
              placeholder="请输入备用手机号（非必填）"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="sparePhoneIcon"
            />
          </div>
          <p
            class="tips"
            :style="{ color: sparePhoneColor }"
            v-if="sparePhoneIcon"
          >
            {{ sparePhoneTips }}
          </p>
        </a-form-item>
        <a-form-item
          style="
                        margin-top: 40px;
                        text-align: right;
                        margin-bottom: 0;
                    "
        >
          <a-button style="margin-right: 10px" @click="addNursingOff"
            >取消</a-button
          >
          <a-button type="primary" @click="addNursingOk" :loading="loading"
            >添加</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 修改护工账号  -->
    <a-modal
      title="编辑护工账号"
      :visible="editNursingPopup"
      :maskClosable="false"
      :width="400"
      @cancel="editNursingOff"
      :footer="null"
    >
      <a-form>
        <a-form-item label="">
          <div class="login_input" :style="{ borderColor: nameColor }">
            <input
              type="text"
              v-model="detailsData.name"
              maxlength="18"
              placeholder="请输入姓名"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="nameIcon"
            />
          </div>
          <p class="tips" :style="{ color: nameColor }">
            {{ nameTips }}
          </p>
        </a-form-item>
        <a-form-item label="">
          <div class="login_input" :style="{ borderColor: phoneColor }">
            <input
              type="text"
              autocomplete="off"
              v-model="detailsData.mobile"
              maxlength="11"
              placeholder="请输入手机号"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="phoneIcon"
            />
          </div>
          <p class="tips" :style="{ color: phoneColor }" v-if="phoneIcon">
            {{ phoneTips }}
          </p>
        </a-form-item>
        <a-form-item label="">
          <div class="login_input" :style="{ borderColor: passwordColor }">
            <input
              type="text"
              placeholder="请输入密码"
              autocomplete="off"
              v-model="detailsData.password"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="passwordIcon"
            />
          </div>
          <p class="tips" :style="{ color: passwordColor }" v-if="passwordIcon">
            密码不可为空
          </p>
        </a-form-item>
        <a-form-item label="">
          <div class="login_input" :style="{ borderColor: sparePhoneColor }">
            <input
              type="text"
              autocomplete="off"
              maxlength="11"
              v-model="detailsData.reserveMobile"
              placeholder="请输入备用手机号（非必填）"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="sparePhoneIcon"
            />
          </div>
          <p
            class="tips"
            :style="{ color: sparePhoneColor }"
            v-if="sparePhoneIcon"
          >
            {{ sparePhoneTips }}
          </p>
        </a-form-item>
        <a-form-item
          style="
                        margin-top: 40px;
                        text-align: right;
                        margin-bottom: 0;
                    "
        >
          <a-button style="margin-right: 10px" @click="editNursingOff"
            >取消</a-button
          >
          <a-button type="primary" @click="editNursingOk" :loading="loading"
            >确定</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 添加床位 -->
    <a-modal
      title="添加床位"
      :visible="addBedPopup"
      :maskClosable="false"
      :width="500"
      @cancel="addBedOff"
      :footer="null"
      class="bedModel"
    >
      <div class="topNum">
        <div>共{{ bedValue }}床位</div>
        <div>
          已选<span> {{ bedNum }} </span>床位
        </div>
      </div>
      <a-tree
        v-if="treeData.length"
        v-model="checkedKeys"
        checkable
        :default-expand-all="autoExpandParent"
        :auto-expand-parent="autoExpandParent"
        :tree-data="treeData"
        style="margin-top: 14px"
      />
      <div class="treeBtn">
        <a-button style="margin-right: 10px" @click="addBedOff">取消</a-button>
        <a-button type="primary" @click="addBedOk" :loading="loading"
          >确定</a-button
        >
      </div>
    </a-modal>
    <!-- 删除弹窗 -->
    <a-modal
      title=""
      :width="200"
      :visible="delNursingPopup"
      :footer="null"
      :closable="false"
    >
      <p class="delTips">
        <a-icon type="exclamation-circle" />你确定要删除吗？
      </p>
      <div class="delBtn">
        <a-button style="margin-right: 10px" @click="delNursingCancel"
          >取消</a-button
        >
        <a-button type="primary" @click="delNursingOk" :loading="loading"
          >确定</a-button
        >
      </div>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: '姓名',
    key: 'name',
    dataIndex: 'name',
    width: '8%',
    align: 'center',
  },
  {
    title: '手机号',
    key: 'mobile',
    dataIndex: 'mobile',
    width: '12%',
    align: 'center',
  },
  {
    title: '备用手机号',
    key: 'reserveMobile',
    dataIndex: 'reserveMobile',
    width: '12%',
    align: 'center',
  },
  // {
  //     title: "密码",
  //     key: "password",
  //     dataIndex: "password",
  //     width: "8%",
  //     align: "center",
  // },
  {
    title: '负责床位',
    width: '62%',
    align: 'center',
    scopedSlots: { customRender: 'beds' },
  },
  {
    title: '操作',
    width: '9%',
    align: 'center',
    scopedSlots: { customRender: 'operation' },
  },
];

export default {
  data() {
    return {
      searchVal: '', //
      tableData: [], // 数据
      columns,
      loading: false, // 添加人员账号确定loading
      addNursingPopup: false, // 添加护工人员账号弹窗状态
      addBedPopup: false, // 添加床位弹窗状态
      editNursingPopup: false, // 修改人员弹窗状态
      delNursingPopup: false, // 删除弹窗
      addListData: {
        name: '', // 姓名
        phone: '', // 手机号
        password: '', // 密码
        selectVal: '', // 账号类型
        reserveMobile: '', // 备用手机号
      },
      nameTips: '姓名只支持字母、数字或汉字，最多可输入18个字符', // 姓名填写提示
      nameColor: '#BFBFBF', // 提示默认字体颜色
      nameIcon: false, // 姓名警告状态
      phoneTips: '', // 手机号填写提示
      phoneColor: '#BFBFBF', // 提示默认字体颜色
      phoneIcon: false, // 手机号警告状态
      sparePhoneTips: '', // 手机号填写提示
      sparePhoneColor: '#BFBFBF', // 提示默认字体颜色
      sparePhoneIcon: false, // 手机号警告状态
      passwordColor: '#BFBFBF', // 提示默认字体颜色
      passwordIcon: false, // 密码警告状态
      pageNum: 1,
      pageSize: 20,
      total: 0,
      detailsData: {}, // 获取人员详情

      autoExpandParent: true,
      checkedKeys: [],
      treeData: [], // 床位tree数据
      bedValue: '', // 床的数量
      allCheckedList: [],
      bedNum: '', // 已选床位数量
      searchValIsHide: true,
    };
  },
  watch: {
    checkedKeys(val) {
      var arr = val.filter(function(o) {
        return !isNaN(o);
      });
      this.bedNum = arr.length;
      console.log('onCheck', val);
    },
  },
  created() {
    if (
      this.$getCookie('userInfo').user.roleId == 2 ||
      this.$getCookie('userInfo').user.roleId == 3
    ) {
      this.$router.go(1);
    }
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    // 获取表格数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        name: this.searchVal,
      };
      this.$get(
        '/api/nurse',
        param,
        (res) => {
          if (res.code == 0) {
            if (res.data.rows) {
              for (let i = 0; i < res.data.rows.length; i++) {
                res.data.rows[i].password = '******';
              }
              this.tableData = res.data.rows;
            } else {
              this.tableData = [];
            }
            this.total = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 分页
    pageChange(e) {
      console.log(e);
      this.pageNum = e;
      this.getTableData();
    },
    // 监听tree选择
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    // 搜索
    onSearch() {
      this.getTableData();
      this.searchValIsHide = false;
    },
    // 搜索返回
    backBtn() {
      this.searchVal = '';
      this.searchValIsHide = true;
      this.getTableData();
    },
    // 添加人员确定
    addNursingOk() {
      let nameReg = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
      // 姓名验证
      if (this.addListData.name) {
        if (
          nameReg.test(this.addListData.name) &&
          this.addListData.name.length <= 18
        ) {
          this.nameTips = '姓名只支持字母、数字或汉字，最多可输入18个字符';
          this.nameColor = '#BFBFBF';
          this.nameIcon = false;
        } else {
          this.nameTips = '姓名只支持字母、数字或汉字，最多可输入18个字符';
          this.nameColor = '#FF4D4F';
          this.nameIcon = true;
          return;
        }
      } else {
        this.nameTips = '姓名不可为空';
        this.nameColor = '#FF4D4F';
        this.nameIcon = true;
        return;
      }
      let phoneReg = /^1[3456789]\d{9}$/;
      // 手机号验证
      if (this.addListData.phone) {
        if (phoneReg.test(this.addListData.phone)) {
          this.phoneColor = '#BFBFBF';
          this.phoneIcon = false;
        } else {
          this.phoneTips = '请输入正确的手机号码';
          this.phoneColor = '#FF4D4F';
          this.phoneIcon = true;
          return;
        }
      } else {
        this.phoneTips = '手机号不可为空';
        this.phoneColor = '#FF4D4F';
        this.phoneIcon = true;
        return;
      }
      if (this.addListData.phone === this.addListData.reserveMobile) {
        this.sparePhoneTips = '备用手机号码不能和账户手机号一样';
        this.sparePhoneColor = '#FF4D4F';
        this.sparePhoneIcon = true;
        return;
      }
      // 密码验证
      if (this.addListData.password) {
        this.passwordColor = '#BFBFBF';
        this.passwordIcon = false;
      } else {
        this.passwordColor = '#FF4D4F';
        this.passwordIcon = true;
        return;
      }
      let param = {
        name: this.addListData.name, // 姓名
        mobile: this.addListData.phone, // 手机号
        password: this.addListData.password, // 密码
        roleId: '3', // 1管理员 2院长 3护工
        reserveMobile: this.addListData.reserveMobile,
      };
      this.loading = true;
      this.$post(
        '/api/user',
        param,
        (res) => {
          if (res.code == 0) {
            this.$message.success('添加成功');
            this.addNursingPopup = false;
            this.getTableData();
            this.addListData = {
              name: '', // 姓名
              phone: '', // 手机号
              password: '', // 密码
              reserveMobile: '', // 备用手机号
            };
            this.nameTips = '姓名只支持字母、数字或汉字，最多可输入18个字符';
            this.nameColor = '#BFBFBF';
            this.nameIcon = false;
            this.phoneColor = '#BFBFBF';
            this.phoneIcon = false;
            this.sparePhoneColor = '#BFBFBF';
            this.sparePhoneIcon = false;
          } else {
            this.$message.error(res.msg);
            if (res.msg == '姓名已经存在') {
              this.nameTips = '姓名在本机构已经存在，请尝试换一个姓名';
              this.nameColor = '#FF4D4F';
              this.nameIcon = true;
            }
          }
          this.loading = false;
        },
        (err) => {
          this.loading = false;
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 确定人员取消
    addNursingOff() {
      this.addNursingPopup = false;
      this.addListData = {
        name: '', // 姓名
        phone: '', // 手机号
        password: '', // 密码
        sparePhone: '',
      };
      this.nameTips = '姓名只支持字母、数字或汉字，最多可输入18个字符';
      this.nameColor = '#BFBFBF';
      this.nameIcon = false;
      this.phoneColor = '#BFBFBF';
      this.phoneIcon = false;
      this.sparePhoneColor = '#BFBFBF';
      this.sparePhoneIcon = false;
    },
    // 获取床位tree信息
    getBedTreeData() {
      this.$get(
        '/api/bed/treeList',
        { userId: this.typeId },
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              for (var i = 0; i < res.data.children.length; i++) {
                res.data.children[i].title =
                  res.data.children[i].title +
                  '（' +
                  res.data.children[i].value +
                  '床位）';
                if (res.data.children[i].children) {
                  for (
                    var n = 0;
                    n < res.data.children[i].children.length;
                    n++
                  ) {
                    res.data.children[i].children[n].title =
                      res.data.children[i].children[n].title +
                      '（' +
                      res.data.children[i].children[n].value +
                      '床位）';
                    for (
                      var k = 0;
                      k < res.data.children[i].children[n].children.length;
                      k++
                    ) {
                      res.data.children[i].children[n].children[k].title =
                        res.data.children[i].children[n].children[k].title +
                        '（' +
                        res.data.children[i].children[n].children[k].value +
                        '床位）';
                      for (
                        var j = 0;
                        j <
                        res.data.children[i].children[n].children[k].children
                          .length;
                        j++
                      ) {
                        // res.data.children[i].children[n].children[k].children[j].disabled = res.data.children[i].children[n].children[k].children[j].disabled;
                        // res.data.children[i].children[n].children[k].children[j].disabled = false;
                      }
                    }
                  }
                }
              }
              this.treeData = res.data.children;
              console.log(this.treeData);
              this.bedValue = res.data.value;
            }
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 添加床位按钮
    addBedClick(e) {
      this.addBedPopup = true;
      this.typeId = e.userId;
      if (e.beds) {
        for (var i = 0; i < e.beds.length; i++) {
          this.allCheckedList.push(e.beds[i].bedId);
          this.checkedKeys.push(e.beds[i].bedId + '');
        }
      } else {
        this.checkedKeys = [];
      }
      this.bedNum = e.beds ? e.beds.length : 0;
      console.log(this.checkedKeys);
      this.getBedTreeData();
    },
    // 添加床位取消
    addBedOff() {
      this.addBedPopup = false;
      this.checkedKeys = [];
    },
    // 添加床位确定
    addBedOk() {
      let checkedKeys = [];
      for (var i = 0; i < this.checkedKeys.length; i++) {
        checkedKeys.push(this.checkedKeys[i] * 1);
      }
      var arr = checkedKeys.filter(function(o) {
        return !isNaN(o);
      });
      this.bedNum = arr.length;
      console.log(arr, this.allCheckedList);
      let addBedIdsList = [];
      for (var i = 0; i < arr.length; i++) {
        var isEquals = false;
        for (var j = 0; j < this.allCheckedList.length; j++) {
          if (arr[i] == this.allCheckedList[j]) {
            isEquals = true;
            break;
          }
        }
        if (!isEquals) {
          addBedIdsList.push(arr[i]);
        }
      }
      let param = {
        addBedIds: addBedIdsList,
        delBedIds: [],
        userId: this.typeId,
      };
      this.$post(
        '/api/nurse/relateBeds',
        param,
        (res) => {
          if (res.code == 0) {
            this.getTableData();
            this.checkedKeys = [];
            this.addBedPopup = false;
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 获取人员详情
    getDetailsData() {
      this.$get(
        '/api/user/' + this.typeId,
        {},
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              this.detailsData = res.data;
              this.detailsData.password = '';
            }
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 修改人员按钮
    edit(e) {
      this.editNursingPopup = true;
      this.typeId = e.userId;
      this.getDetailsData();
    },
    // 修改人员取消
    editNursingOff() {
      this.editNursingPopup = false;
      this.sparePhoneColor = '#BFBFBF';
      this.sparePhoneIcon = false;
    },
    // 修改人员确定
    editNursingOk() {
      let param = {
        name: this.detailsData.name, // 姓名
        mobile: this.detailsData.mobile, // 手机号
        reserveMobile: this.detailsData.reserveMobile, // 手机号
        password: this.detailsData.password, // 密码
        roleId: 3, // 1管理员 2院长 3护工
        userId: this.typeId,
      };
      if (this.detailsData.password != '') {
        this.passwordColor = '#BFBFBF';
        this.passwordIcon = false;
      } else {
        this.passwordColor = '#FF4D4F';
        this.passwordIcon = true;
        return;
      }
      if (this.detailsData.mobile === this.detailsData.sparePhone) {
        this.sparePhoneTips = '备用手机号码不能和账户手机号一样';
        this.sparePhoneColor = '#FF4D4F';
        this.sparePhoneIcon = true;
        return;
      }
      this.loading = true;
      this.$put(
        '/api/user',
        param,
        (res) => {
          if (res.code == 0) {
            this.$message.success('修改成功');
            this.getTableData();
            this.loading = false;
            this.editNursingPopup = false;
          } else {
            this.$message.error(res.msg);
          }
          this.loading = false;
        },
        (err) => {
          this.loading = false;
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 删除账号按钮
    delAccount(e) {
      this.typeId = e.userId;
      this.delNursingPopup = true;
    },
    // 确认删除账号
    delNursingOk() {
      this.loading = true;
      this.$delete(
        '/api/user/' + this.typeId,
        {},
        (res) => {
          if (res.code == 0) {
            this.$message.success('删除成功');
            this.getTableData();
            this.delNursingPopup = false;
          } else {
            this.$message.error(res.msg);
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.loading = false;
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 删除取消
    delNursingCancel() {
      this.delNursingPopup = false;
    },
    // 删除床位绑定
    delBed(id, userId) {
      let param = {
        addBedIds: [],
        delBedIds: [id],
        userId: userId,
      };
      this.$post(
        '/api/nurse/relateBeds',
        param,
        (res) => {
          if (res.code == 0) {
            this.getTableData();
            this.$message.success('删除成功');
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.main::v-deep {
  padding: 0 !important;
  .btns {
    margin-bottom: 10px;
    .leftSearch {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    p {
      margin-bottom: 0;
      span {
        color: #1890ff;
      }
    }
  }
  .ant-table-thead > tr > th {
    background: #f0f0f0;
  }
  .ant-table-tbody {
    .ant-table-row:nth-child(even) {
      background: #fafafa;
    }
  }
  .ant-table-bordered .ant-table-header > table,
  .ant-table-bordered .ant-table-body > table,
  .ant-table-bordered .ant-table-fixed-left table,
  .ant-table-bordered .ant-table-fixed-right table {
    width: 100%;
  }
  .ant-table-content {
    min-height: 1134px;
  }
  .ant-table-thead
    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-tbody
    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-thead
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background: none;
  }
  .ant-table-row td:nth-child(4) {
    padding-bottom: 6px;
  }
  .addBed {
    color: #1890ff;
    display: flex;
    align-items: center;
    .bedChoice {
      display: flex;
      flex-wrap: wrap;
      .bedItem {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 32px;
        line-height: 32px;
        // padding: 6px 12px;
        // width: 160px;
        background: #e6f7ff;
        color: #1890ff;
        margin-bottom: 10px;
        margin-right: 10px;
        padding: 0 12px;
        span {
          flex: 1;
          text-align: left;
          margin-right: 6px;
        }
        .close {
          color: #1890ff;
          cursor: pointer;
        }
      }
      .bedItem:hover {
        background: #bae7ff;
      }
    }
    .addBtn {
      display: flex;
      align-items: center;
      cursor: pointer;
      padding-bottom: 10px;
      .iconBtn {
        margin-right: 6px;
      }
    }
    .addBtn:hover {
      .iconBtn {
        color: #0072db;
      }
      text-decoration: underline;
    }
  }
  .operation {
    display: flex;
    align-items: center;
    justify-content: center;
    .tableIcon {
      color: #1890ff;
      font-size: 20px;
      margin: 0 10px;
      cursor: pointer;
    }
    .tableIcon:hover {
      color: #0072db;
    }
    .tableImg {
      width: 18px;
      height: 20px;
      cursor: pointer;
      background: url('../../assets/icon_trashCan_nor.png') no-repeat center;
    }
    .tableImg:hover {
      background: url('../../assets/icon_trashCan_ove.png') no-repeat center;
    }
    .tableImg1 {
      width: 18px;
      height: 20px;
      cursor: pointer;
      background: url('../../assets/btn_reset_nor.png') no-repeat center;
    }
    .tableImg1:hover {
      background: url('../../assets/btn_reset_hover.png') no-repeat center;
    }
  }
}
.login_input {
  display: flex;
  position: relative;
  width: 100%;
  height: 16px;
  padding-bottom: 13px;
  border-bottom: 1px solid;
  box-sizing: content-box;
  img {
    width: 16px;
    height: 16px;
    margin: 0 22px 0 16px;
  }
  input {
    flex: 1;
    border: 0; // 去除未选中状态边框
    outline: none; // 去除选中状态边框
    background-color: rgba(0, 0, 0, 0) !important;
    padding-right: 46px;
    height: 16px !important;
    line-height: 16px !important;
  }
  input:-webkit-autofill {
    transition: background-color 5000s ease-in-out 0s;
  }
  input::-webkit-input-placeholder {
    color: #bfbfbf;
  }
  input:-moz-placeholder {
    color: #bfbfbf;
  }
  input::-moz-placeholder {
    color: #bfbfbf;
  }
  input:-ms-input-placeholder {
    color: #bfbfbf;
  }
  .cu {
    cursor: pointer;
  }
}
.tips {
  font-size: 14px;
  margin-bottom: 0;
  line-height: 20px;
  // position: absolute;
  width: 486px;
}
.ant-form-item {
  margin-bottom: 40px;
}
.treeBtn {
  text-align: right;
}
.delTips {
  .anticon {
    color: #faad14;
    margin-right: 10px;
  }
}
.delBtn {
  text-align: right;
  .ant-btn {
    height: 24px;
    line-height: 24px;
    border-radius: 2px;
    text-align: center;
    font-size: 14px;
  }
}
.bedModel::v-deep {
  .ant-modal-body {
    position: relative;
    .topNum {
      width: 100%;
      height: 36px;
      background: #f0f0f0;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #262626;
      font-size: 14px;
      padding: 0 12px;
      span {
        color: #1890ff;
      }
    }
  }
}
</style>
